import { gql } from "@apollo/client";

// Fragment for dialog fields
export const DIALOG_FRAGMENT = gql`
	fragment DialogFields on Dialog {
		_id
		mode
		from {
			device {
				type
				id
			}
			individual {
				id
				name
			}
			group {
				id
				name
				relationship
			}
		}
		to {
			device {
				type
				id
			}
			individual {
				id
				name
			}
			group {
				id
				name
				relationship
			}
		}
		connections {
			id
			collection
		}
		status
		starred
		data
		start
		lastMessageAt
		unreadByBuyer
		unreadBySeller
		createdAt
		updatedAt
	}
`;

// Get a single dialog
export const GET_DIALOG = gql`
	${DIALOG_FRAGMENT}
	query GetDialog($dialogId: ID!) {
		dialog(params: { one: { dialogId: $dialogId } }) {
			one {
				...DialogFields
			}
		}
	}
`;

// Get dialogs for a buyer unit
// Get dialogs for a buyer unit
export const GET_DIALOGS_FOR_BUYER_UNIT = gql`
	${DIALOG_FRAGMENT}
	query GetDialogsForBuyerUnit($buyerUnitId: ID!, $limit: Int, $paginationToken: String) {
		dialog(params: { forBuyerUnit: { buyerUnitId: $buyerUnitId, limit: $limit, paginationToken: $paginationToken } }) {
			forBuyerUnit {
				items {
					...DialogFields
				}
				totalCount
				nextPageToken
				lastBuyerOffer {
					...DialogFields
				}
				lastSellerOffer {
					...DialogFields
				}
			}
		}
	}
`;

// Send a text message
export const SEND_TEXT_MESSAGE = gql`
	${DIALOG_FRAGMENT}
	mutation SendTextMessage($dialogId: ID!, $content: String!) {
		dialog(params: { sendTextMessage: { dialogId: $dialogId, content: $content } }) {
			sendTextMessage {
				...DialogFields
			}
		}
	}
`;

// Send an offer
export const SEND_OFFER = gql`
	${DIALOG_FRAGMENT}
	mutation SendOffer($dialogId: ID!, $amount: Float!, $counterOfferId: ID, $senderRole: String, $senderGroupId: ID) {
		dialog(
			params: {
				sendOffer: {
					dialogId: $dialogId
					amount: $amount
					counterOfferId: $counterOfferId
					senderRole: $senderRole
					senderGroupId: $senderGroupId
				}
			}
		) {
			sendOffer {
				...DialogFields
			}
		}
	}
`;

// Respond to an offer
export const RESPOND_TO_OFFER = gql`
	${DIALOG_FRAGMENT}
	mutation RespondToOffer($dialogId: ID!, $messageId: ID!, $response: String!) {
		dialog(params: { respondToOffer: { dialogId: $dialogId, messageId: $messageId, response: $response } }) {
			respondToOffer {
				...DialogFields
			}
		}
	}
`;

// Mark messages as read
export const MARK_MESSAGES_READ = gql`
	mutation MarkMessagesRead($dialogId: ID!, $messageIds: [ID!]!) {
		dialog(params: { markMessagesRead: { dialogId: $dialogId, messageIds: $messageIds } }) {
			markMessagesRead
		}
	}
`;

// Create a chat dialog
export const CREATE_CHAT_DIALOG = gql`
	${DIALOG_FRAGMENT}
	mutation CreateChatDialog($buyerUnitId: ID!, $dialogId: ID) {
		dialog(params: { createChatDialog: { buyerUnitId: $buyerUnitId, dialogId: $dialogId } }) {
			createChatDialog {
				...DialogFields
			}
		}
	}
`;

// Initiate a call between buyer and seller
export const INITIATE_DIALOG_CALL = gql`
	mutation InitiateDialogCall($dialogId: ID!) {
		dialog(params: { initiateCall: { dialogId: $dialogId } }) {
			initiateCall {
				success
				callId
				error
			}
		}
	}
`;

// Get unread counts for all buyer units in a buyer group
export const GET_UNREAD_COUNTS_FOR_BUYER_GROUP = gql`
	query GetUnreadCountsForBuyerGroup($buyerGroupId: ID!) {
		dialog(params: { unreadCountsForBuyerGroup: { buyerGroupId: $buyerGroupId } }) {
			unreadCountsForBuyerGroup {
				buyerUnitId
				unreadByBuyer
			}
		}
	}
`;

// Get unread counts for all seller units in a seller group
export const GET_UNREAD_COUNTS_FOR_SELLER_GROUP = gql`
	query GetUnreadCountsForSellerGroup($sellerGroupId: ID!) {
		dialog(params: { unreadCountsForSellerGroup: { sellerGroupId: $sellerGroupId } }) {
			unreadCountsForSellerGroup {
				sellerUnitId
				unreadBySeller
			}
		}
	}
`;
